import { render, staticRenderFns } from "./dialog_select_category.vue?vue&type=template&id=796ddb03"
import script from "./dialog_select_category.vue?vue&type=script&lang=js"
export * from "./dialog_select_category.vue?vue&type=script&lang=js"
import style0 from "./dialog_select_category.vue?vue&type=style&index=0&id=796ddb03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports